module.exports = __webpack_public_path__ + "static/media/close.bd8587d5.svg";